import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    name: 'action-tracker-v2',
    path: '/action-tracker-v2',
    meta: {
      requiresAuth: true,
      module: 'action-tracker-v2',
      layout: 'home',
      allowedRoles: [...allowed.action_tracker_v2.roles],
      breadcrumb: {
        label: 'core.menu.main.action-tracker',
        route: 'action-tracker-v2',
      },
    },
    component: () =>
      import(
        '@/modules/action-tracker-v2/components/action-tracker-v2/index.vue'
      ),
    children: [
      {
        path: '',
        name: 'action-tracker-v2-home',
        component: () =>
          import(
            '@/modules/action-tracker-v2/containers/overview/index.vue'
          ),
      },
      {
        path: 'overview',
        name: 'action-tracker-v2-overview',
        meta: {
          allowedRoles: [...allowed.action_tracker_v2.completeSideMenu],
          breadcrumb: {
            label: 'act2-overview.title',
            route: 'action-tracker-v2-overview',
          },
        },
        component: () =>
          import(
            '@/modules/action-tracker-v2/containers/overview/index.vue'
          ),
      },
      {
        path: 'my-actions',
        name: 'action-tracker-v2-my-actions',
        meta: {
          allowedRoles: [...allowed.action_tracker_v2.onlyMyActions],
          breadcrumb: {
            label: 'action-tracker-v2-my-actions.title',
            route: 'action-tracker-v2-my-actions',
          },
        },
        component: () =>
          import(
            '@/modules/action-tracker-v2/containers/my-actions/index.vue'
          ),
      },
      {
        path: 'action-plans',
        name: 'action-tracker-v2-action-plans',
        meta: {
          allowedRoles: [...allowed.action_tracker_v2.completeSideMenu],
          breadcrumb: {
            label: 'core.menu.modules.action-tracker-v2-action-plans',
            route: 'action-tracker-v2-action-plans',
          },
        },
        component: () =>
          import(
            '@/modules/action-tracker-v2/containers/action-tracker-v2-action-plans/index.vue'
          ),
      },
      {
        path: 'action-plans/:id',
        name: 'action-tracker-v2-action-plans-id',
        meta: {
          breadcrumb: {
            label: 'core.menu.modules.action-tracker-v2-action-plans',
            route: 'action-tracker-v2-action-plans-id',
          },
        },
        component: () =>
          import(
            '@/modules/action-tracker-v2/containers/action-tracker-v2-action-plans/index.vue'
          ),
      },
      {
        path: 'module-settings',
        name: 'action-tracker-v2-module-settings',
        meta: {
          allowedRoles: [...allowed.action_tracker_v2.settings],
          breadcrumb: {
            label: 'core.menu.modules.action-tracker-v2-module-settings',
            route: 'module-settings',
          },
        },
        component: () =>
          import(
            '@/modules/action-tracker-v2/containers/action-tracker-v2-settings/index.vue'
          ),
      },
    ],
  },
]

export default index
